/**
 * The share price change across a series, from its first to its last point with a value. Core's
 * daily history has no share price on the days a vault holds nothing, which often opens All time.
 */
export function toVariationValues(
  points: ReadonlyArray<readonly [number, number | null]>
): { past: number; present: number } | null {
  const valued = points.filter((point): point is readonly [number, number] => point[1] !== null)
  const first = valued[0]
  const last = valued.at(-1)
  if (valued.length < 2 || first === undefined || last === undefined) return null
  return { past: first[1], present: last[1] }
}
